export default __webpack_public_path__ + "static/media/host-infographic.74eb40c0.png";